function initFaqSection(root) {
  if (!root || root.dataset.faqInitialized === "true") return;
  root.dataset.faqInitialized = "true";

  var singleOpen = root.dataset.singleOpen === "true";
  var buttons = Array.prototype.slice.call(root.querySelectorAll("[data-faq-toggle]"));

  function closeItem(btn) {
    var answer = document.getElementById(btn.getAttribute("aria-controls"));
    btn.setAttribute("aria-expanded", "false");
    if (answer) answer.style.maxHeight = null;
  }

  function openItem(btn) {
    var answer = document.getElementById(btn.getAttribute("aria-controls"));
    btn.setAttribute("aria-expanded", "true");
    if (answer) answer.style.maxHeight = answer.scrollHeight + "px";
  }

  buttons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var isOpen = btn.getAttribute("aria-expanded") === "true";

      if (singleOpen) {
        buttons.forEach(function (b) {
          if (b !== btn) closeItem(b);
        });
      }

      if (isOpen) {
        closeItem(btn);
      } else {
        openItem(btn);
      }
    });
  });

  // Keep open answers correctly sized if content reflows (e.g. window resize, font load).
  window.addEventListener("resize", function () {
    buttons.forEach(function (btn) {
      if (btn.getAttribute("aria-expanded") === "true") {
        var answer = document.getElementById(btn.getAttribute("aria-controls"));
        if (answer) answer.style.maxHeight = answer.scrollHeight + "px";
      }
    });
  });
}

function initAllFaqSections(scope) {
  var root = scope || document;
  root.querySelectorAll("[data-faq-section]").forEach(initFaqSection);
}

document.addEventListener("DOMContentLoaded", function () {
  initAllFaqSections();
});

// Re-init when a merchant adds/reloads this section in the theme editor.
document.addEventListener("shopify:section:load", function (event) {
  initAllFaqSections(event.target);
});
